import React, { useState } from "react";
import "./experience.css";
const Experience = () => {
  const [readMoreText1, setReadMore1] = useState(false);
  const [readMoreText2, setReadMore2] = useState(false);
  const [readMoreText3, setReadMore3] = useState(false);
  const [readMoreText4, setReadMore4] = useState(false);
  return (
    <div className="experienceContainer">
      <h2 className="experienceHeading">Involvement</h2>
      <div className="titleUnderline"></div>
      <h1 className="experienceHeading2">My Experience</h1>
      <div className="experienceItems">
        <div className="experienceItem1">
          <div className="experienceCalander1">
            <span className="date">2021</span>
            <span className="months">Dec to Feb</span>
            <span className="date">2022</span>
          </div>
          <div className="experienceContent">
            <h2>
              Senior React <span className="reactColor">Developer</span>
            </h2>
            <span className="subTitile reactColor">Hash Technologies</span>
            <div className="experienceUnderline"></div>
            {readMoreText1 ? (
              <p>
                I was working as a Senior React Developor on Hash Techologies
                Located at Rainbow Galli, Jahada Road, Biratnagar-10. During
                this time period, I have done more then 4 react real time
                projets.
              </p>
            ) : (
              <p>
                I was working as a Senior React Developor on Hash Techologies
                Located at Rainbow Galli, Jahada Road, Biratnagar-10.
              </p>
            )}
            <span
              className="readMore"
              onClick={() => setReadMore1(!readMoreText1)}
            >
              {readMoreText1 ? "Read Less" : "Read More"}
            </span>
          </div>
        </div>
        <div className="experienceItem2">
          <div className="experienceCalander2">
            <span className="date">2021</span>
            <span className="months">Aug to Dec</span>
            <span className="date">2022</span>
          </div>
          <div className="experienceContent">
            <h2>
              Senior WordPress <span className="wordpressColor">Developer</span>
            </h2>
            <span className="subTitile wordpressColor">Hash Technologies</span>
            <div className="experienceUnderline"></div>
            {readMoreText2 ? (
              <p>
                I was working as a Senior React Developor in Hash Techologies
                Located at Rainbow Galli, Jahada Road, Biratnagar-10. During
                this time period, I have done 3 ecommerc projets on WordPress
                and other blog website projets.
              </p>
            ) : (
              <p>
                I was working as a Senior React Developor in Hash Techologies
                Located at Rainbow Galli, Jahada Road, Biratnagar-10.
              </p>
            )}
            <span
              className="readMore"
              onClick={() => setReadMore2(!readMoreText2)}
            >
              {readMoreText2 ? "Read Less" : "Read More"}
            </span>
          </div>
        </div>
        <div className="experienceItem3">
          <div className="experienceContent">
            <h2>
              Intern UI/UX <span className="interuiColor">Designer</span>
            </h2>
            <span className="subTitile interuiColor">Digital Pravidhi</span>
            <div className="experienceUnderline"></div>
            {readMoreText3 ? (
              <p>
                I was a learning intern in Digital Pravidhi located at
                Santinagar, Kathmandu Nepal.During this traning period I have
                learned different UI/UX tools like Figma, Adove XD and many
                more.
              </p>
            ) : (
              <p>
                I was a learning intern in Digital Pravidhi located at
                Santinagar, Kathmandu Nepal.
              </p>
            )}
            <span
              className="readMore"
              onClick={() => setReadMore3(!readMoreText3)}
            >
              {readMoreText3 ? "Read Less" : "Read More"}
            </span>
          </div>
          <div className="experienceCalander3">
            <span className="date">2020</span>
            <span className="months">Jan to July</span>
            <span className="date">2021</span>
          </div>
        </div>
        <div className="experienceItem4">
          <div className="experienceContent">
            <h2>
              Senior Web <span className="webColor">Developer</span>
            </h2>
            <span className="subTitile webColor">Digital Pravidhi</span>
            <div className="experienceUnderline"></div>
            {readMoreText4 ? (
              <p>
                I was a senior web designer in Digital Pravidhi located at
                Santinagar, Kathmandu Nepal.During I have completed more than 4
                front-end projects.
              </p>
            ) : (
              <p>
                I was a learning intern in Digital Pravidhi located at
                Santinagar, Kathmandu Nepal.
              </p>
            )}
            <span
              className="readMore"
              onClick={() => setReadMore4(!readMoreText4)}
            >
              {readMoreText4 ? "Read Less" : "Read More"}
            </span>
          </div>
          <div className="experienceCalander4">
            <span className="date">2019</span>
            <span className="months">Jan to Sept </span>
            <span className="date">2020</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Experience;
